//常用工具类
import store from '@/store';

function cleanArray(actual) {
    const newArray = []
    for (let i = 0; i < actual.length; i++) {
        if (actual[i]) {
            newArray.push(actual[i])
        }
    }
    return newArray
}

//对象转查询参数
export function param(json) {
    if (!json) return ''
    return cleanArray(Object.keys(json).map(key => {
        if (json[key] === undefined) return ''
        return encodeURIComponent(key) + '=' +
            encodeURIComponent(json[key])
    })).join('&')
}

//深拷贝
export function deepClone(source) {
    return JSON.parse(JSON.stringify(source))
}


//region 扩展方法
Date.prototype.format = function (fmt) {
    var o = {
        "M+": this.getMonth() + 1,                 //月份
        "d+": this.getDate(),                    //日
        "h+": this.getHours(),                   //小时
        "m+": this.getMinutes(),                 //分
        "s+": this.getSeconds(),                 //秒
        "q+": Math.floor((this.getMonth() + 3) / 3), //季度
        "S": this.getMilliseconds()             //毫秒
    };
    if (/(y+)/.test(fmt))
        fmt = fmt.replace(RegExp.$1, (this.getFullYear() + "").substr(4 - RegExp.$1.length));
    for (var k in o)
        if (new RegExp("(" + k + ")").test(fmt))
            fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
    return fmt;
}

Array.prototype.contains = function (obj) {
    var i = this.length;
    while (i--) {
        if (this[i] == obj) {
            return true;
        }
    }
    return false;
}

export function emptyArr(arr){
    return emptyObj(arr) || arr.length < 1;
}

export function emptyObj(obj){
    return obj === null || obj === undefined || obj === '';
}

export function isSuperAccount(){ // 是否是超管
    var user = store.getters.account;
    if (emptyObj(user)) {
        return false;
    }
    var type = user.accountType;
    return type == 3;
}

export function getCurAccGroupId(){ // 获取当前用户的部门ID
    var user = store.getters.account;
    return "1";
}

//endregion


// WEBPACK FOOTER //
// ./src/utils/index.js